// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"330":"b55e6495","598":"49dacccf","624":"7b4610f8","635":"c082601f"}[chunkId] + ".chunk.css";
};